<template>
  <div
    id="app-wrapper-web"
    class="d-lg-flex flex-lg-column m-auto "
    :class="{ 'bg-main-low': isHome, 'bg-main': !isHome }"
  >
    <div class="d-flex bar-side h-100">
      <menu-header
        v-if="menuCanBeDisplayed()"
        class="d-none d-lg-inline-block w-20 bg-light background"
        :userIsAParent="userIsAParent"
        @changeTheme="changeTheme"
      />
      <div class="d-flex flex-column w-25 flex-grow-1">
        <responsive-menu-header
          v-if="menuCanBeDisplayed()"
          :userIsAParent="userIsAParent"
          :childId="childId"
          :themeIndex="sessionStore.themeSelection"
          @changeTheme="changeTheme"
        />
        <router-view class="flex-grow-1 bg-white h-100 app-wrapper-content" />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import ResponsiveMenuHeader from './ResponsiveHeaderMenu.vue';
import MenuHeader from './MenuHeader.vue';

//Store
import { useSessionStore } from '@/common';
import { setChangeParentTheme, setChangeChildTheme } from '@/common/services';

// Requests
import { loadUserData, getChildrenData, persisteChildSelection } from '@/auth';

export default {
  name: 'app',
  components: {
    ResponsiveMenuHeader,
    MenuHeader,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      ONE_CHILD: 1,
    };
  },
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    isHome() {
      return this.$route.name === 'home';
    },
    childId() {
      return `${this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId}`;
    },
    userId() {
      return this.sessionStore.userId;
    },
    iMustGoToTheFirstTimeModule() {
      return (
        (this.sessionStore.isFirstTime && !this.userIsAParent) ||
        (this.sessionStore.isFirstTime && this.userIsAParent && !this.sessionStore.children.length)
      );
    },
    noChildHasBeenSelected() {
      return this.userIsAParent && this.sessionStore.childSelectedId === '';
    },
  },
  methods: {
    menuCanBeDisplayed() {
      return (
        (this.userIsAParent && this.childId) ||
        (!this.userIsAParent && !this.sessionStore.isFirstTime)
      );
    },
    async changeTheme(colorIndex) {
      if (this.userIsAParent) {
        try {
          await setChangeParentTheme(this.userId, colorIndex);
          this.sessionStore.themeSelection = colorIndex;
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          await setChangeChildTheme(this.userId, colorIndex);
          this.sessionStore.themeSelection = colorIndex;
        } catch (error) {
          console.log(error);
        }
      }
    },
    goToFirstTime(to, next) {
      if (to.name !== 'first-time') {
        if (this.iMustGoToTheFirstTimeModule) return next('first-time');
      }
    },
    goToChildList(to, next) {
      if (to.name !== 'childList') {
        if (this.noChildHasBeenSelected) {
          const childCount = this.sessionStore.children.length;

          if (!childCount) return next();
          if (childCount > 1) return next('childList');

          const child = this.sessionStore.children[0];
          persisteChildSelection(`${child.id}`);
          this.sessionStore.childSelectedId = `${child.id}`;
        }
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    const sessionStore = useSessionStore();
    if (!sessionStore.profileType) {
      await loadUserData();
    }
    if (sessionStore.userIsAParent) await getChildrenData(sessionStore.userId);

    next((vm) => {
      vm.goToFirstTime(to, next);
    });

    next((vm) => {
      vm.goToChildList(to, next);
    });

    next();
  },
};
</script>
